import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { 
  fetchPortfolioPercentage, 
  fetchHoldings, 
  fetchRankings, 
  fetchRecentTrades 
} from '../services/api';

export const useAppData = () => {
  const [holdings, setHoldings] = useState([]);
  const [rankings, setRankings] = useState([]);
  const [portfolioPercentage, setPortfolioPercentage] = useState(null);
  const [ndaqPercentage, setNdaqPercentage] = useState(null);
  const [spyPercentage, setSpyPercentage] = useState(null);
  const [arkkPercentage, setArkkPercentage] = useState(null);
  const [trades, setTrades] = useState([]);
  const [currentTab, setCurrentTab] = useState('home');
  const location = useLocation();

  useEffect(() => {
    // Fetch all data on mount
    const loadData = async () => {
      const portfolioData = await fetchPortfolioPercentage();
      setPortfolioPercentage(portfolioData.portfolioPercentage);
      setNdaqPercentage(portfolioData.ndaqPercentage);
      setSpyPercentage(portfolioData.spyPercentage);
      setArkkPercentage(portfolioData.arkkPercentage);

      const holdingsData = await fetchHoldings();
      setHoldings(holdingsData);

      const rankingsData = await fetchRankings();
      setRankings(rankingsData);

      const tradesData = await fetchRecentTrades();
      setTrades(tradesData);
    };

    loadData();
  }, []);

  useEffect(() => {
    // Set active tab based on current path
    // Handle HashRouter - check both pathname and hash
    let path = location.pathname;
    if (location.hash) {
      path = location.hash.substring(1); // Remove the #
    }
    const tab = path.substring(1) || 'home';
    setCurrentTab(tab);
  }, [location.pathname, location.hash]);

  return {
    holdings,
    rankings,
    portfolioPercentage,
    ndaqPercentage,
    spyPercentage,
    arkkPercentage,
    trades,
    currentTab,
    setCurrentTab,
  };
};
